<template>
  <div
    class="relative flex p-1.5 bg-fill-dark rounded-2xl border border-white/5 shadow-inner"
  >
    <div
      class="absolute top-1.5 bottom-1.5 transition-all duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] bg-white/5 rounded-[10px] border border-white/10"
      :style="{
        width: `calc(${100 / props.tabs.length}% - 12px)`,
        left: `calc(${(props.tabs.findIndex((t) => t.id === props.activeTab) * 100) / props.tabs.length}% + 6px)`,
      }"
    ></div>

    <button
      v-for="tab in props.tabs"
      :key="tab.id"
      type="button"
      class="relative z-10 flex-1 px-4 py-2.5 text-sm font-bold transition-all duration-300 rounded-xl cursor-pointer focus:outline-none"
      :class="[
        props.activeTab === tab.id
          ? 'text-white'
          : 'text-text-weak-dark hover:text-text-strong-dark hover:bg-white/2',
      ]"
      @click="() => emit('update:activeTab', tab.id)"
    >
      <span
        class="transition-colors duration-300"
        :style="props.activeTab === tab.id ? { color: activeColor } : {}"
      >
        {{ tab.label }}
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const emit = defineEmits<{
  (e: "update:activeTab", value: string): void;
}>();

const props = defineProps<{
  tabs: { id: string; label: string }[];
  activeTab: string;
  activeColor?: string;
}>();

// Defaulting to the Pebble Brand color (#FF5F00)
const activeColor = computed(() => props.activeColor ?? "#FF5F00");
</script>
